import { render, staticRenderFns } from "./SubHeaderDiscovery.vue?vue&type=template&id=3a7f2c9c"
import script from "./SubHeaderDiscovery.vue?vue&type=script&lang=js"
export * from "./SubHeaderDiscovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports